export default function CAEditCustomerDirective() {
  return {
    template: require('./edit-customer.directive.html'),
    scope: {
      customer: '=',
      services: '=',
    },
    controller: 'CAEditCustomerDirectiveController',
    controllerAs: 'editCustomerVM',
    bindToController: true,
    replace: true,
  };
}
